import {
	IEvidentlyProvider,
	IEvidentlyOverrideProvider,
	EvaluateFeatureArgs,
	FeatureEvaluation,
	FeatureOverrideViewModel,
} from '../types';

export default class EvidentlyMockProvider implements IEvidentlyProvider, IEvidentlyOverrideProvider {
	featureEvaluations: Record<string, FeatureEvaluation> = {};

	configure = () => {};

	reset = async (): Promise<FeatureOverrideViewModel[]> => {
		this.featureEvaluations = {};
		return [];
	};

	getFeatureOverridesViewModel = async () => [];

	setFeatureOverride = (featureName: string, override: FeatureEvaluation) => {
		this.featureEvaluations[featureName] = override;
	};

	evaluateFeature = async <T extends 'bool' | 'string' | 'long' | 'double'>({
		featureName,
		defaultVariation,
	}: EvaluateFeatureArgs<T>) => {
		const overrideVariation = this.featureEvaluations[featureName];
		return (overrideVariation ? (overrideVariation.variationValue as any) : defaultVariation.value) as Promise<
			T extends 'bool' ? boolean : T extends 'string' ? string : number
		>;
	};

	captureMetric = () => {};
}
